import { createAction } from '@reduxjs/toolkit';
import {
  AdminUserResponse,
  AuthMethodsResponse,
  CreateAdminRequest,
  GetUsersListResponse,
  UpdateAdminRequest,
} from 'features/admin-users/api/types';

export const adminUsersActions = {
  clearState: createAction('[admin_users]CLEAR_ADMIN_USERS_STATE'),
  getAdminUsersListRequest: createAction<{
    page: number;
    selectedRole?: number;
    search?: string;
    limit: number;
  }>('[admin_users]GET_ADMIN_USERS_LIST_REQUEST'),
  getAdminUsersListSuccess: createAction<GetUsersListResponse>(
    '[admin_users]GET_ADMIN_USERS_LIST_SUCCESS'
  ),
  getAdminUsersListFailure: createAction<string[]>(
    '[admin_users]GET_ADMIN_USERS_LIST_FAILURE'
  ),
  createUserRequest: createAction<CreateAdminRequest>(
    '[admin_users]CREATE_USER_REQUEST'
  ),
  createUserSuccess: createAction<AdminUserResponse>(
    '[admin_users]CREATE_USER_SUCCESS'
  ),
  createUserFailure: createAction<string[]>('[admin_users]CREATE_USER_FAILURE'),

  getUserRequest: createAction<{ userId: number }>(
    '[admin_users]GET_USER_REQUEST'
  ),
  getUserSuccess: createAction<AdminUserResponse>(
    '[admin_users]GET_USER_SUCCESS'
  ),
  getUserFailure: createAction<string[]>('[admin_users]GET_USER_FAILURE'),

  updateUserRequest: createAction<{ data: UpdateAdminRequest; userId: number }>(
    '[admin_users]UPDATE_USER_REQUEST'
  ),
  updateUserSuccess: createAction<AdminUserResponse>(
    '[admin_users]UPDATE_USER_SUCCESS'
  ),
  updateUserFailure: createAction<string[]>('[admin_users]UPDATE_USER_FAILURE'),

  deleteUserRequest: createAction<{ userId: number }>(
    '[admin_users]DELETE_USER_REQUEST'
  ),
  deleteUserSuccess: createAction<number>('[admin_users]DELETE_USER_SUCCESS'),
  deleteUserFailure: createAction<string[]>('[admin_users]DELETE_USER_FAILURE'),
  deleteUsersRequest: createAction<number[]>(
    '[admin_users]DELETE_USERS_REQUEST'
  ),
  deleteUsersSuccess: createAction<number[]>(
    '[admin_users]DELETE_USERS_SUCCESS'
  ),
  deleteUsersFailure: createAction<string[]>(
    '[admin_users]DELETE_USERS_FAILURE'
  ),

  getAuthMethodsRequest: createAction<{ partnerName: string }>(
    '[admin_users]GET_AUTH_METHODS_REQUEST'
  ),
  getAuthMethodsSuccess: createAction<AuthMethodsResponse>(
    '[admin_users]GET_AUTH_METHODS_SUCCESS'
  ),
  getAuthMethodsFailure: createAction<string[]>(
    '[admin_users]GET_AUTH_METHODS_FAILURE'
  ),
};
